import { render, staticRenderFns } from "./FacturaInfo.vue?vue&type=template&id=866b858a"
import script from "./FacturaInfo.vue?vue&type=script&lang=js"
export * from "./FacturaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports